module.exports = __webpack_public_path__ + "static/media/DSC03865.80cf9336.jpg";